import { accessRoster } from '@/permissions/roster';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/roster',
		children: [
			{
				path: '',
				name: 'Roster',
				component: () => import('@/views/RosterIndex.vue'),
				meta: {
					layout: 'LayoutAuthenticated',
					requiresAuth: true,
					title: 'pageRoster.metaTitle',
					permissionRule: accessRoster,
				},
			},
		],
	},
];

export default routes;
